import React from 'react';
import PropTypes from 'prop-types';
import { Input, Select, Card } from '@ipc/ipc-components';

import { FormLabel } from '../../../elements';

import { REQUEST_TYPE_OPTIONS } from '../constants';

const MainInfoComponent = ({
  values, disabled, onInputChange, onSelectChange, validations,
}) => (
  <Card>
    <div className="FormRow">
      <FormLabel title="Settlement Record Name" required hasError={!validations.requestName}>
        <Input value={values.requestName} name="requestName" onChange={onInputChange} huge className="Input StyledInput" />
      </FormLabel>
    </div>

    <div className="FormRow">
      <FormLabel title="Type" required>
        <Select options={REQUEST_TYPE_OPTIONS} value={values.requestType} className="Input SingleSelect" onChange={onSelectChange} name="requestType" isDisabled={disabled} />
      </FormLabel>
    </div>
  </Card>
);

MainInfoComponent.propTypes = {
  values: PropTypes.shape(),
  validations: PropTypes.shape(),
  disabled: PropTypes.bool,
  onInputChange: PropTypes.func,
  onSelectChange: PropTypes.func,
};

export default MainInfoComponent;
